export enum CurrencyCode {
    USD = 'USD'
}
